import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import getAccount from "Redux/Actions/GetAccountAction";
import AppConstants from "Constants/AppConstants";
import {
  getProductFromVault,
  updateVaultProductList,
  updateProductToVault,
} from "Components/MarketPlace/Action/MarketPlaceAction";
import withApplicantHOC from "Hoc/ApplicantHOC/ApplicantHOC";
import LoanDetails from "./LoanDetails";
import {
  getFinancialList,
  getLoanProduct,
  updateLendingProduct,
  updateLoanProductForm,
} from "./Actions/LoanDetailsAction";
import LoanAuto from "./LoanAuto";
import LoanHeloc from "./LoanHeloc";
import LoanLoc from "./LoanLoc";
import LoanMortgage from "./LoanMortgage";
import * as ROUTES from "../../Constants/Routes";
import { add, format } from "date-fns";

class LoanDetailsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      choice: "",
    };
  }

  componentDidMount() {
    const { doGetLoanProduct } = this.props;
    doGetLoanProduct();
    this.initializeLoanDetail();
  }

  componentDidUpdate(prevProps) {}

  handleChange = () => {};

  handleContinue = (loanProductForm) => {
    console.log("handleContinue", loanProductForm);
    const { continuehandler } = this.props;
    this.updateFormToProductVault(loanProductForm);
  };

  updateLoanForm = (loanProductForm) => {
    console.log(loanProductForm);
    const { updateLoanProductForm } = this.props;
    updateLoanProductForm(loanProductForm);
    console.log(this.props.loanProductForm);
  };

  updateFormToProductVault(loanProductForm) {
    console.log("updateFormToProductVault", loanProductForm);
    const { products, getActiveProduct, doUpdateProductToVault } = this.props;
    const activeProduct = getActiveProduct(products);
    let loanDetails = activeProduct.loanDetails;
    console.log(loanDetails);
    if (loanDetails) {
      loanDetails["estimatedMortgage"] = loanProductForm.estimatedMortgage;
      loanDetails["loanAmount"] = loanProductForm.loanAmount;
      loanDetails["vehiclePrice"] = loanProductForm.vehiclePrice;
      loanDetails["loanRate"] = loanProductForm.loanRate;
      loanDetails["loanTerm"] = loanProductForm.loanTerm;
      loanDetails["monthlyPayment"] = loanProductForm.monthlyPayment;
      loanDetails["loanScheduleDate"] = loanProductForm.loanScheduleDate;
      loanDetails["paymentType"] = loanProductForm.paymentType;
      loanDetails["downPayment"] = loanProductForm.downPayment;
      loanDetails["downPaymentPercent"] = loanProductForm.downPaymentPercent;
      loanDetails["amortization"] = loanProductForm.amortization;
      loanDetails["assessedValue"] = loanProductForm.assessedValue;
      loanDetails["mortgageBalance"] = loanProductForm.mortgageBalance;
      this.updateDoxim(activeProduct, loanDetails);
      products[0]["loanDetails"] = loanDetails;
      doUpdateProductToVault(products, () => {});
    } else {
      products[0]["loanDetails"] = loanProductForm;
      this.updateDoxim(activeProduct, products[0]["loanDetails"]);
      doUpdateProductToVault(products, () => {});
    }
  }

  handleCancelApplication = () => {
    const { history, products, doUpdateProductToVault } = this.props;
    products.splice(0, 1);
    doUpdateProductToVault(products, () => {
      history.push(ROUTES.VAULT_DASHBOARD);
    });
  };

  getTermYears(loanTerm) {
    return Math.floor(loanTerm / 12);
  }

  getTermMonths(loanTerm) {
    const years = Math.floor(loanTerm / 12) * 12;
    return loanTerm - years;
  }

  getFirstPaymentDate(startDate, paymentType) {
    const endDate = new Date(startDate);
    if (paymentType === "weekly") {
      endDate.setDate(endDate.getDate() + 7);
    } else if (paymentType === "biweekly") {
      endDate.setDate(endDate.getDate() + 14);
    } else {
      endDate.setDate(endDate.getDate() + 30);
    }
    console.log("endDate", endDate);
    return endDate;
  }

  updateDoxim(activeProduct, loanDetails) {
    const { doUpdateLendingProduct, continuehandler } = this.props;
    console.log("updateDoxim", loanDetails);
    let payLoad = {};
    const currentDate = new Date();
    const futureDate = add(currentDate, { days: 30 });
    if (activeProduct.templateId === 6) {
      if (activeProduct.category === AppConstants.LOAN_CATEGORY.PERSONAL) {
        payLoad = {
          LPBasicDetails: {
            NewMoney: loanDetails.loanAmount,
            PurposeCode: activeProduct.loanPurposeCode,
          },
          LPTermsDetails: {
            TermYears: this.getTermYears(loanDetails.loanTerm),
            TermMonths: this.getTermMonths(loanDetails.loanTerm),
            MonthlyPayment: loanDetails.monthlyPayment,
            AmortYears: this.getTermYears(loanDetails.loanTerm),
            AmortMonths: this.getTermMonths(loanDetails.loanTerm),
            QualAmortYears: 0,
            QualAmortMonths: 0,
            StressAmortYears: 0,
            StressAmortMonths: 0,
            CompoundingFrequencyCode: "2",
            RateType: "fixed",
            PrePayTypeCode: "1",
            RateCommittedDate: format(currentDate, "yyyy-MM-dd"),
            QualifyingRate: 0,
            StressRate: 0,
            BaseRate: loanDetails.loanRate,
            IncrementRate: 1.1,
            DiscretionRate: 0,
            PaymentFrequency: loanDetails.paymentType,
            PaymentTypeCode: "Blended",
            FirstPaymentDate: format(
              this.getFirstPaymentDate(currentDate, loanDetails.paymentType),
              "yyyy-MM-dd"
            ),
            PayDay: 6,
            // InterestAdjustmentDate: "2020-07-23",
            QualifyingPayment: 0,
            OverrideQualifyingPayment: false,
            PreferredPayment: 0,
            OverridePreferredPayment: true,
          },
        };
      } else if (activeProduct.category === AppConstants.LOAN_CATEGORY.LOC) {
        payLoad = {
          LPBasicDetails: {
            NewMoney: loanDetails.loanAmount,
            PurposeCode: activeProduct.loanPurposeCode,
          },
        };
      } else if (activeProduct.category === AppConstants.LOAN_CATEGORY.AUTO) {
        payLoad = {
          LPBasicDetails: {
            NewMoney: loanDetails.loanAmount,
            PurposeCode: activeProduct.loanPurposeCode,
          },
          LPTermsDetails: {
            TermYears: this.getTermYears(loanDetails.loanTerm),
            TermMonths: this.getTermMonths(loanDetails.loanTerm),
            AmortYears: this.getTermYears(loanDetails.loanTerm),
            AmortMonths: this.getTermMonths(loanDetails.loanTerm),
          },
        };
      }

      doUpdateLendingProduct(
        activeProduct.applicationId,
        activeProduct.doximProductId,
        payLoad,
        (res) => {
          console.log(res);
          continuehandler(null, AppConstants.APPLICATIONSTEP.LOAN_DETAILS);
        }
      );
    } else {
      if (activeProduct.category === AppConstants.LOAN_CATEGORY.MORTGAGE) {
        payLoad = {
          LPBasicDetails: {
            ProductDescription: "Residential Mtg",
            PurposeCode: activeProduct.loanPurposeCode,
            ClassCode: "10",
            ProductCode: "MFR",
            AdvanceTypeCode: "1",
            NewMoney: loanDetails.estimatedMortgage,
            StartDate: format(currentDate, "yyyy-MM-dd"),
            AllowThirdParty: true,
            PurposeOfCredit: "loan",
            ProductType: "Mortgage",
            securityCode: "PPS",
            SecTypeCode: "2",
            lTypeCode: "3",
          },
          LPTermsDetails: {
            TermYears: loanDetails.loanTerm,
            TermMonths: 0,
            AmortYears: loanDetails.amortization,
            AmortMonths: 0,
            CompoundingFrequencyCode: "2",
            RateType: "fixed",
            PrePayTypeCode: "1",
            PaymentFrequency: "monthly",
            PaymentTypeCode: "Blended",
            BaseRate: loanDetails.loanRate,
            IncrementRate: 1.1,
            DiscretionRate: 0,
            FirstPaymentDate: format(futureDate, "yyyy-MM-dd"),
            QualifyingPayment: 0,
            OverrideQualifyingPayment: false,
            PreferredPayment: 0,
            OverridePreferredPayment: true,
          },
          LPFeesDetails: {
            AppraisalInspectionFees: 295,
            AppraisalInspectionFeesFinance: true,
            AppraisalInspectionFeesMandatory: true,
          },
        };
      } else if (activeProduct.category === AppConstants.LOAN_CATEGORY.HELOC) {
        payLoad = {
          LPBasicDetails: {
            NewMoney: loanDetails.loanAmount,
            PurposeCode: activeProduct.loanPurposeCode,
          },
        };
      }
      doUpdateLendingProduct(
        activeProduct.applicationId,
        activeProduct.doximProductId,
        payLoad,
        (res) => {
          console.log(res);
          continuehandler(null, AppConstants.APPLICATIONSTEP.LOAN_DETAILS);
        }
      );
    }
  }

  initializeLoanDetail() {
    const {
      loanProducts,
      products,
      getActiveProduct,
      doGetFinancialList,
      doUpdateProductToVault,
    } = this.props;
    const activeProduct = getActiveProduct(products);
    console.log(activeProduct);
    if (!activeProduct) {
      return;
    }
    const productId = activeProduct.productId;
    let purposes = [];
    let paymentTypes = [];
    let loanConfig = {};
    console.log(loanProducts);
    if (loanProducts) {
      loanProducts.forEach((raw, idx) => {
        if (raw.id === productId) {
          purposes = raw.purpose;
          paymentTypes = raw.paymentTypes;
          loanConfig = {
            loanAmount: raw.loanAmount,
            loanTerm: raw.loanTerm,
            loanRate: raw.loanRate,
          };
        }
      });
    }

    let loanDetails = activeProduct.loanDetails;

    if (loanDetails) {
      updateLoanProductForm(loanDetails);
    }
    if (!activeProduct.finAnalysisId) {
      doGetFinancialList({ applicantId: activeProduct.applicantId }, (res) => {
        if (res) {
          res.forEach((raw, idx) => {
            if (raw.applicationId == activeProduct.applicationId) {
              products[0]["finAnalysisId"] = raw.finAnalysisId;
              doUpdateProductToVault(products, () => {});
            }
          });
        }
      });
    }
  }

  render() {
    const { choice, loanPurposes, paymentTypes, loanConfig } = this.state;
    const {
      getDataFromServer,
      handleBack,
      steps,
      activeStepID,
      loanProducts,
      loanProductForm,
      getActiveProduct,
      products,
    } = this.props;
    const activeProduct = getActiveProduct(products);
    console.log(loanProducts);
    let loanProduct = {};
    try {
      loanProduct = loanProducts
        ? loanProducts.find((loan) => loan.id === activeProduct.productId)
        : {};
    } catch (e) {}
    return (
      <>
        {loanProduct?.category === AppConstants.LOAN_CATEGORY.AUTO && (
          <LoanAuto
            handleContinue={this.handleContinue}
            handleChange={this.handleChange}
            updateLoanForm={this.updateLoanForm}
            getDataFromServer={getDataFromServer}
            choice={choice}
            handleBack={handleBack}
            steps={steps}
            activeStepID={activeStepID}
            products={products}
            loanProducts={loanProducts}
            loanPurposes={loanPurposes}
            paymentTypes={paymentTypes}
            loanConfig={loanConfig}
            loanProductForm={loanProductForm}
            activeProduct={activeProduct}
            getActiveProduct={getActiveProduct}
          />
        )}
        {loanProduct?.category === AppConstants.LOAN_CATEGORY.HELOC && (
          <LoanHeloc
            handleContinue={this.handleContinue}
            handleChange={this.handleChange}
            updateLoanForm={this.updateLoanForm}
            getDataFromServer={getDataFromServer}
            choice={choice}
            handleBack={handleBack}
            steps={steps}
            activeStepID={activeStepID}
            products={products}
            loanProducts={loanProducts}
            loanPurposes={loanPurposes}
            paymentTypes={paymentTypes}
            loanConfig={loanConfig}
            loanProductForm={loanProductForm}
            activeProduct={activeProduct}
            getActiveProduct={getActiveProduct}
            handleCancelApplication={this.handleCancelApplication}
          />
        )}
        {loanProduct?.category === AppConstants.LOAN_CATEGORY.LOC && (
          <LoanLoc
            handleContinue={this.handleContinue}
            handleChange={this.handleChange}
            updateLoanForm={this.updateLoanForm}
            getDataFromServer={getDataFromServer}
            choice={choice}
            handleBack={handleBack}
            steps={steps}
            activeStepID={activeStepID}
            products={products}
            loanProducts={loanProducts}
            loanPurposes={loanPurposes}
            paymentTypes={paymentTypes}
            loanConfig={loanConfig}
            loanProductForm={loanProductForm}
            activeProduct={activeProduct}
            getActiveProduct={getActiveProduct}
          />
        )}
        {loanProduct?.category === AppConstants.LOAN_CATEGORY.MORTGAGE && (
          <LoanMortgage
            handleContinue={this.handleContinue}
            handleChange={this.handleChange}
            updateLoanForm={this.updateLoanForm}
            getDataFromServer={getDataFromServer}
            choice={choice}
            handleBack={handleBack}
            steps={steps}
            activeStepID={activeStepID}
            products={products}
            loanProducts={loanProducts}
            loanPurposes={loanPurposes}
            paymentTypes={paymentTypes}
            loanConfig={loanConfig}
            loanProductForm={loanProductForm}
            activeProduct={activeProduct}
            getActiveProduct={getActiveProduct}
          />
        )}
        {loanProduct?.category === AppConstants.LOAN_CATEGORY.PERSONAL && (
          <LoanDetails
            handleContinue={this.handleContinue}
            handleChange={this.handleChange}
            updateLoanForm={this.updateLoanForm}
            getDataFromServer={getDataFromServer}
            choice={choice}
            handleBack={handleBack}
            steps={steps}
            activeStepID={activeStepID}
            products={products}
            loanProducts={loanProducts}
            loanPurposes={loanPurposes}
            paymentTypes={paymentTypes}
            loanConfig={loanConfig}
            loanProductForm={loanProductForm}
            activeProduct={activeProduct}
            getActiveProduct={getActiveProduct}
          />
        )}
      </>
    );
  }
}

LoanDetailsContainer.propTypes = {
  getDataFromServer: PropTypes.func.isRequired,
  continuehandler: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
  getActiveProduct: PropTypes.func,
};

LoanDetailsContainer.defaultProps = {
  steps: [],
  activeStepID: -1,
  getActiveProduct: () => {},
};

const mapStateToProps = (state) => ({
  MemberExists: state.MemberExistsReducer,
  products: state.VaultReducer.vaultProductList,
  loanProducts: state.LoanDetailsReducer.loanProducts,
  loanProductForm: state.LoanDetailsReducer.loanProductForm,
});

const mapDispatchToProps = (dispatch) => {
  return {
    doGetAcoountDetails: (callback) => dispatch(getAccount(callback)),
    doGetProductFromVault: (callback) =>
      dispatch(getProductFromVault(callback)),
    doGetLoanProduct: (callback) => dispatch(getLoanProduct(callback)),
    updateLoanProductForm: (loanProductForm, callback) =>
      dispatch(updateLoanProductForm(loanProductForm, callback)),
    doUpdateProductToVault: (vaultProductList, callback) =>
      dispatch(updateProductToVault(vaultProductList, callback)),
    doUpdateLendingProduct: (
      applicationId,
      doximProductId,
      payLoad,
      callback
    ) =>
      dispatch(
        updateLendingProduct(applicationId, doximProductId, payLoad, callback)
      ),
    doGetFinancialList: (reqData, callback) =>
      dispatch(getFinancialList(reqData, callback)),
  };
};

const LoanDetailsWrapper = withApplicantHOC(LoanDetailsContainer);
export default connect(mapStateToProps, mapDispatchToProps)(LoanDetailsWrapper);
